import { render } from "./Ljb.vue?vue&type=template&id=2fd1b77e&scoped=true"
import script from "./Ljb.vue?vue&type=script&lang=js"
export * from "./Ljb.vue?vue&type=script&lang=js"

import "./Ljb.vue?vue&type=style&index=0&id=2fd1b77e&scoped=true&lang=stylus"

import exportComponent from "/Users/test/Desktop/source/work/H5-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fd1b77e"]])

export default __exports__